module.exports = __webpack_public_path__ + "img/Station Rendering_02_LRT.34f29552.jpg";